import React from 'react';
import PropTypes from 'prop-types';

import { Text, PasswordInput } from '../index';

import { StyledCard } from './style';

export const AccountCard = ({ onChange, data, errors }) => {
    return (
        <div>
            <StyledCard variant="outlined" padding="20px">
                <Text $bold $fontSize="18px" style={{ marginBottom: '10px' }}>
                    ID / Password
                </Text>
                <PasswordInput
                    id="oldPassword"
                    label="Old password"
                    placeholder="Old Password"
                    name="oldPassword"
                    required
                    onChange={onChange}
                    value={data?.oldPassword}
                    helperText={errors.find((error) => error.property === 'oldPassword')?.message}
                />
                <PasswordInput
                    id="newPassword"
                    label="New password"
                    placeholder="New password"
                    name="newPassword"
                    required
                    onChange={onChange}
                    value={data?.newPassword}
                    helperText={errors.find((error) => error.property === 'newPassword')?.message}
                />
                <PasswordInput
                    id="confirmNewPassword"
                    label="Confirm new password"
                    placeholder="Confirm new password"
                    name="confirmPassword"
                    required
                    onChange={onChange}
                    value={data?.confirmPassword}
                    helperText={errors.find((error) => error.property === 'confirmPassword')?.message}
                />
            </StyledCard>
        </div>
    );
};

AccountCard.propTypes = {
    onChange: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    errors: PropTypes.arrayOf(PropTypes.object),
};
